import { useEffect, useRef } from "react";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { CircleExclamationFilledIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectShowVersionMismatchWarning } from "store/selectors/view";
import { GENERAL_EVENT_CATEGORY, trackEvent } from "utils/amplitude";
import { clearCacheAndReload } from "utils/urls";

export const Banners = () => {
  const hasTrackedBannerRef = useRef<boolean>(false);
  const showVersionMismatchWarning = useAppSelector(selectShowVersionMismatchWarning);

  useEffect(() => {
    if (showVersionMismatchWarning && !hasTrackedBannerRef.current) {
      hasTrackedBannerRef.current = true;
      trackEvent("Outdated version banner displayed", GENERAL_EVENT_CATEGORY);
    }
  }, [showVersionMismatchWarning]);

  if (showVersionMismatchWarning) {
    return (
      <Banner
        actionButtonText={t("warning.version_mismatch.reload_button")}
        className="rounded-none border-0 border-b border-blue-tint-40 pl-4"
        closeEventName="Outdated version banner - Dismiss"
        eventName="Outdated version banner - Refresh now"
        Icon={CircleExclamationFilledIcon}
        kind="info"
        onAction={clearCacheAndReload}
      >
        {t("warning.version_mismatch.message")}
      </Banner>
    );
  }

  return null;
};
